/* ==========================================================================
   LoadingInformation > Client > Prototype
   ========================================================================== */

/* Modules */
const { addToStore, removeFromStore } = require('@bluekiri/alexandria/helpers/store');
const config = require('./config');

/* Store */
let store = [];

/* Prototype */
const prototype = {
    /* Add body container */
    addBody: function Fn() {
        /* Create body node to add the content */
        const bodyEl = document.createElement('div');
        bodyEl.classList.add(config().css.body);
        bodyEl.dataset.body = '';

        this.element.appendChild(bodyEl);
    },
    /* Get body element */
    getBodyEl: function Fn() {
        return this.element.querySelector('[data-body]');
    },
    /* Get message element */
    getMessageEl: function Fn() {
        return this.element.querySelector('[data-message]');
    },
    /* Get description element */
    getDescriptionEl: function Fn() {
        return this.element.querySelector('[data-description]');
    },
    /* Get title element */
    getTitleEl: function Fn() {
        return this.element.querySelector('[data-title]');
    },
    /* Get image element */
    getImageEl: function Fn() {
        if (!this.image) return false;

        return this.image.getImageEl();
    },
    /* Get elements */
    getEl: function Fn() {
        return {
            message: this.getMessageEl(),
            description: this.getDescriptionEl(),
            title: this.getTitleEl(),
            image: this.getImageEl()
        };
    },
    /**
     * Get
     * @returns {object} Current values { image, title, description, message }
     */
    get: function Fn() {
        return {
            message: this.getMessageEl() ? this.getMessageEl().innerText : false,
            description: this.getDescriptionEl() ? this.getDescriptionEl().innerText : false,
            title: this.getTitleEl() ? this.getTitleEl().innerText : false,
            image: this.getImageEl() ? this.getImageEl().src : false
        };
    },
    /* Set message text */
    setMessage: function Fn(message = '') {
        /* Message */
        if (!this.getMessageEl()) {
            /* Check body */
            if (!this.getBodyEl()) this.addBody();

            /* Create message node to add the text */
            const messageEl = document.createElement('p');
            messageEl.classList.add(config().css.message);
            messageEl.dataset.message = '';

            this.getBodyEl().appendChild(messageEl);
        }

        /* Set message */
        this.getMessageEl().innerText = message;

        return this;
    },
    /* Set description text */
    setDescription: function Fn(description = '') {
        /* Description */
        if (!this.getDescriptionEl()) {
            /* Check body */
            if (!this.getBodyEl()) this.addBody();

            /* Create description node to add the text */
            const descriptionEl = document.createElement('p');
            descriptionEl.classList.add(config().css.description);
            descriptionEl.dataset.description = '';

            this.getBodyEl().appendChild(descriptionEl);
        }

        /* Set description */
        this.getDescriptionEl().innerText = description;

        return this;
    },
    /* Set title text */
    setTitle: function Fn(title = '') {
        /* Title */
        if (!this.getTitleEl()) {
            /* Check body */
            if (!this.getBodyEl()) this.addBody();

            /* Create title node to add the text */
            const titleEl = document.createElement('p');
            titleEl.classList.add(config().css.title);
            titleEl.dataset.title = '';

            this.getBodyEl().appendChild(titleEl);
        }

        /* Set title */
        this.getTitleEl().innerText = title;

        return this;
    },
    /* Set image src */
    setImage: function Fn(src) {
        if (!this.image) return this;

        this.image.setImage(src, {
            operation: this.config.image.resize.operation,
            suboperation: this.config.image.resize.suboperation,
            width: this.config.image.resize.width,
            height: this.config.image.resize.height,
            quality: this.config.image.resize.quality
        });

        return this;
    },
    /**
     * Set
     * @param {object} data Object containing the data to set { image, title, description, message }
     * @returns {object} Current instance
     */
    set: function Fn({ title = false, description = false, message = false, image = false } = {}) {
        if (title) this.setTitle(title);
        if (description) this.setDescription(description);
        if (message) this.setMessage(message);
        if (image) this.setImage(image);

        return this;
    },
    /* Add to dom */
    addToDom: function Fn() {
        document.body.appendChild(this.element);

        return this;
    },

    /* Remove from dom */
    removeFromDom: function Fn() {
        if (document.contains(this.element)) this.element.parentNode.removeChild(this.element);

        return this;
    },
    /* Add to store */
    addToStore: function Fn() {
        /* Control unique instances of same modal */
        if (this.getStore().filter(item => item.type === this.type).length > 0) return this;

        /* Quarry function */
        addToStore(this, store);

        return this;
    },

    /* Remove from store */
    removeFromStore: function Fn() {
        store = removeFromStore(this, store);

        return this;
    },

    /* Get store */
    getStore: function Fn() {
        return store;
    },
    /* Init chain */
    init: function init() {
        /* Image */
        if (this.image) this.image.init();

        /* Add to store */
        if (this.config.autoStore) this.addToStore();

        return this;
    }
};

module.exports = prototype;
